import React from 'react';
import ArtifactViewLink from '~/sidebarNav/components/ArtifactViewLink';
import { Link } from 'react-router';
import VulnMethodSupportStatus from '~/utils/VulnMethodSupportStatus';
type ArtifactViewNavProps = {
  artifactState: object;
  expandedSubOption?: string;
  mobile?: boolean;
  user?: object;
};
const ArtifactViewNav: React.SFC<ArtifactViewNavProps> = props => {
  const { user = {} } = props;
  const { profile } = user;
  let expandedSubOption = props.expandedSubOption,
    artifactState = props.artifactState,
    artifact = artifactState.artifact,
    activeArtifactId = artifact.id,
    affectedComponents = artifactState.affectedComponents || [],
    languageType = affectedComponents[0] ? affectedComponents[0].languageType : '',
    language = languageType.toLowerCase(),
    activeArtifactUrl = artifactState.activeUrl,
    activeTab = artifactState.activeTab || '',
    hasExploits = artifact.exploits && artifact.exploits.length,
    submenuOptions = {
      summary: 'Summary',
      technical: 'Technical Details',
      risk: 'Risk Score',
      fix: 'Library Fix Info',
      exploit: 'Exploit Info',
      references: 'References',
      signatures: 'Library Signatures',
      vulnMethods: 'Vulnerable Methods',
    },
    submenuOptionsElements = [],
    roles,
    hideExploitInfo = false,
    isMobileNav = props.mobile;
  if (profile) {
    roles = props.user.profile; //AuthFactory.getUser().profile.roles;
  }
  if (!hasExploits) {
    hideExploitInfo = true;
    if (roles) {
      if (
        roles.indexOf('SC_RD_ADMIN') > -1 ||
        roles.indexOf('COMMUNITY_RESEARCHER') > -1 ||
        roles.indexOf('SC_RESEARCHER') > -1
      ) {
        hideExploitInfo = false;
      }
    }
  }
  Object.keys(submenuOptions).forEach(function(option, index) {
    if (option === 'vulnMethods' && !VulnMethodSupportStatus.isLanguageSupported(language)) {
      return;
    }
    if (option === 'exploit' && hideExploitInfo) {
      return;
    }
    submenuOptionsElements.push(
      <div className="grid" key={option + index}>
        <div className="grid__item col-1-1">
          <ArtifactViewLink
            title={submenuOptions[option]}
            activeTab={activeTab}
            subtab={option}
            baseUrl={activeArtifactUrl}
            artifactId={activeArtifactId}
          />
        </div>
      </div>
    );
  });
  if (!activeArtifactId) {
    return null;
  }
  if (isMobileNav) {
    return (
      <div className="grid">
        <div className="grid__item col-1-1">{submenuOptionsElements}</div>
      </div>
    );
  }
  return (
    <div className="grid" data-automation-id="ArtifactViewNav--SideNav-Header">
      <Link
        className={
          'grid__item col-1-1 pv- cursor--pointer link--no-underline' +
          (expandedSubOption === 'artifact-view'
            ? ' link--primary color--primary'
            : ' hover-background--white-light')
        }
        to={activeArtifactUrl + '/' + activeTab}
      >
        <div className="grid grid--full grid--middle">
          <div className="grid__item col-1-6 font--h5 pl--">
            <i className="sci sci__vulnerability sci--fw" />
          </div>
          <div className="grid__item col-5-6 font--h7 pl--">
            <div className="col-1-1 font--h7">Vulnerability</div>
            <div className="col-1-1 font--h7">SRCCLR-SID-{activeArtifactId}</div>
          </div>
        </div>
      </Link>
    </div>
  );
};
export default ArtifactViewNav;
